import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import DropdownInput from '../../../core/DropdownInput';
import Modal from '../../../core/Modal';
import Icon from '../../../core/Icon';
import { StyledModalContent } from '../../../core/Modal/style';

const StyledModal = styled(Modal)`
  ${mediaqueries.greaterThan('desktop')`
    ${StyledModalContent} {
      padding: ${rem('50px')} ${rem('78px')};
    }
  `};
`;

const StyleModalNew = styled(Modal)``;

const WrapperCollapsed = styled.div`
  display: none;
  padding: ${rem('10px')} 0;
  ${props =>
    props.expanded &&
    `
      display: block;
  `};
`;

const StyledIconDrop = styled(Icon)`
  left: -${rem('25px')};
  margin-top: 0.2rem;
  position: absolute;
  top: 0;
  transform: rotate(-90deg);
  ${props =>
    props.expanded &&
    `
    transform: rotate(90deg);
  `};

  ${mediaqueries.greaterThan('desktop')`
    left: -${rem('30px')};
  `};
`;

const RangeDates = styled.div`
  margin-top: ${rem('10px')};
  ${mediaqueries.greaterThan('mobile')`
    display: flex;  
  `};
`;

const ItemRangeDates = styled.span`
  flex-basis: 50%;
  ${mediaqueries.greaterThan('mobile')`
    margin-right: 10%;

    &:last-child {
      margin-right: 0;
    }
  `};
`;

const StyledDropdownInputMonths = styled(DropdownInput)`
  display: inline-block;
  margin: 0 ${rem('10px')} 0 0;
  width: calc(60% - ${rem('10px')});
  ${props =>
    props.disabled &&
    `
      pointer-events: none
  `};
`;

const StyledDropdownInputYears = styled(DropdownInput)`
  display: inline-block;
  width: 40%;
  ${props =>
    props.disabled &&
    `
      pointer-events: none
  `};
`;

export {
  StyledModal,
  StyleModalNew,
  WrapperCollapsed,
  StyledIconDrop,
  StyledDropdownInputMonths,
  StyledDropdownInputYears,
  RangeDates,
  ItemRangeDates
};
